import { render, staticRenderFns } from "./AlertStatsPie.vue?vue&type=template&id=c730d718&scoped=true&"
import script from "./AlertStatsPie.vue?vue&type=script&lang=js&"
export * from "./AlertStatsPie.vue?vue&type=script&lang=js&"
import style0 from "./AlertStatsPie.vue?vue&type=style&index=0&id=c730d718&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c730d718",
  null
  
)

export default component.exports